import { styled } from '@mui/material';
import {
  getImageUrl,
  useGetMerchantFullName,
  useGetMerchantId,
} from '../services/configManager';

interface MerchantLogoProps {
  width?: string;
  height?: string;
  position?: string;
  top?: string;
}

const StyledMerchantLogo = styled('img')<MerchantLogoProps>(() => ({
  position: 'relative',
}));

export const MerchantLogo = (props: MerchantLogoProps) => {
  const merchantId = useGetMerchantId();
  const merchantName = useGetMerchantFullName();

  const merchantLogoUrl = getImageUrl(
    'merchants',
    merchantId,
    'salesAppLogo.png',
  );

  return (
    <StyledMerchantLogo
      data-testid="logo-img"
      alt={`${merchantName} logo`}
      src={merchantLogoUrl}
      {...props}
    />
  );
};
